<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight"
        color="#DADADA"
        dense
        flat
    >
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1"
    >
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>


<script>

import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import viewer from "@/urls/roles/viewer";
import names_core from "@/modules/core/routers/names";

export default {
  name: "ViewerFieldsList",
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список полей сведений",
      dialog_add_edit: false,
      dialog_delete: false,
      field_data: undefined,
      edit_status: undefined,
      headers: [
        {text: "Тип пропуска", value: "order_type", sortable: false, align: "start", width: "15%"},
        {text: "Тип поля", value: "field_type", sortable: false, align: "start", width: "15"},
        {text: "Наименование", value: "name", sortable: false, width: "20%"},
        {text: "Помощь", value: "help", sortable: false, width: "15%"},
        {text: "Обязателен", value: "is_required", sortable: false, width: "15%"},
        {text: "Настройки", value: "settings", sortable: false, width: "20%"}
      ]
    }
  },
  computed:{
    ...mapGetters({
      items: "viewer/getFieldsList",
      count: "viewer/getFieldsCount",
      isLoading: "viewer/isLoadingFields"
    })
  },
  methods: {
    ...mapActions({
      loadFieldsList: "viewer/loadFieldsList"
    }),
    loadData(url=undefined){
      this.loadFieldsList({
        url: url,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    if(viewer.VIEWER.ALLOWED()){
      this.loadData(undefined)
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }

}

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
